import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/record.png'


const _hoisted_1 = { class: "_invite-employee _modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "150",
    width: "150"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = { class: "w-full mt-5" }
const _hoisted_7 = { class: "input-group flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal w-2/5" }, " Họ và Tên ", -1)
const _hoisted_9 = {
  key: 1,
  class: "font-bold text-neutral-500 text-right w-full"
}
const _hoisted_10 = {
  key: 0,
  class: "input-group flex items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, null, -1)
const _hoisted_12 = { class: "mt-4 w-full" }
const _hoisted_13 = { class: "error text-sienna-600 text-sm w-full" }
const _hoisted_14 = { class: "input-group flex items-center mt-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal w-2/5" }, " Tên hiển thị ", -1)
const _hoisted_16 = {
  key: 1,
  class: "font-bold text-neutral-500 text-right w-full"
}
const _hoisted_17 = {
  key: 1,
  class: "input-group flex items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, null, -1)
const _hoisted_19 = { class: "mt-4 w-full" }
const _hoisted_20 = { class: "error text-sienna-600 text-sm w-full" }
const _hoisted_21 = {
  key: 2,
  class: "input-group flex items-center mt-5"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal w-2/5" }, " Chức vụ ", -1)
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "org_admin" }, "Quản lý cơ sở", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "admin" }, "Trưởng chuyên môn", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "teacher" }, "Trị liệu viên", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "accountant" }, "Kế toán", -1)
const _hoisted_28 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 3,
  class: "mt-5 flex flex-nowrap items-center"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-sm text-neutral-700" }, " Tự động gửi lời mời liên kết tới email của người sử dụng ", -1)
const _hoisted_31 = {
  key: 4,
  class: "input-group flex items-center mt-5"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal w-2/5" }, " Email ", -1)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 5,
  class: "input-group flex items-center"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, null, -1)
const _hoisted_36 = { class: "mt-4 w-full" }
const _hoisted_37 = { class: "error text-sienna-600 text-sm w-full" }
const _hoisted_38 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center md-down:flex-col-reverse" }
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.invitedValue
						? 'Thêm tài khoản mới thành công'
						: 'Thêm tài khoản mới'), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.invitedValue
						? `Luca đã tạo tài khoản mới cho cơ sở của bạn. Lời mời liên kết đã được gửi tới email của người sử dụng tài khoản này.`
						: `Bạn hãy điền tên hiển thị và chọn vài trò cho tài khoản mới này
                        nhé. Luca mặc định gửi email liên kết tới người dùng tài khoản
                        này, bạn hãy điền email của người sử dụng nhé`), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (!_ctx.invitedValue)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                placeholder: "Phụ huynh xem được thông tin này",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.staff.full_name) = $event)),
                class: _normalizeClass(_ctx.error['full_name'] ? 'input--error' : '')
              }, null, 2)), [
                [_vModelText, _ctx.staff.full_name]
              ])
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.staff.full_name), 1))
        ]),
        (_ctx.error['full_name'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.error['full_name']), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (!_ctx.invitedValue)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "text",
                placeholder: "Nội bộ trung tâm xem được thông tin này",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.staff.name) = $event)),
                class: _normalizeClass(_ctx.error['name'] ? 'input--error' : '')
              }, null, 2)), [
                [_vModelText, _ctx.staff.name]
              ])
            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.staff.name), 1))
        ]),
        (_ctx.error['name'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.error['name']), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.invitedValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("select", {
                  class: "block w-full pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md input w-full",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.staff.role) = $event))
                }, _hoisted_28, 512), [
                  [_vModelSelect, _ctx.staff.role]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.invitedValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_Checkbox, {
                value: _ctx.staff.send_invitation,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.staff.send_invitation) = $event))
              }, null, 8, ["value"]),
              _hoisted_30
            ]))
          : _createCommentVNode("", true),
        (!(_ctx.invitedValue && !_ctx.staff.send_invitation))
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Email của người dùng tài khoản này",
                disabled: _ctx.staff.send_invitation && _ctx.invitedValue,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.staff.email) = $event)),
                class: _normalizeClass(_ctx.error['email'] ? 'input--error' : '')
              }, null, 10, _hoisted_33), [
                [_vModelText, _ctx.staff.email]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.error['email'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.error['email']), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
      }, _toDisplayString(_ctx.invitedValue ? 'Đóng' : 'Thoát'), 1),
      (!(_ctx.invitedValue && _ctx.staff.send_invitation))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button-p text-center whitespace-nowrap",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: _ctx.inProgress
          }, _toDisplayString(_ctx.invitedValue
						? 'Gửi lời mời liên kết tới người dùng'
						: 'Thêm vào hệ thống và gửi lời mời'), 9, _hoisted_39))
        : _createCommentVNode("", true)
    ])
  ]))
}